var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import styled, { css } from "styled-components";
import omit from "lodash.omit";
import { bonfireGet } from "../../theme";
export var DefaultIconSize = "medium";
var IconSizes = {
    large: "36px",
    medium: "30px",
    small: "24px"
};
var iconBaseColor = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return bonfireGet("colors", props.$iconColor || "textDark"); });
var IconStyled = styled.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  fill: ", ";\n  stroke: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  fill: ", ";\n  stroke: ", ";\n"])), function (_a) {
    var $size = _a.$size;
    return IconSizes[$size || DefaultIconSize];
}, function (_a) {
    var $size = _a.$size;
    return IconSizes[$size || DefaultIconSize];
}, iconBaseColor, iconBaseColor, iconBaseColor);
export var IconBaseSvg = React.forwardRef(function (props, ref) { return (React.createElement(IconStyled, __assign({ ref: ref, "$size": props.size, "$iconColor": props.iconColor }, omit(props, "size", "iconColor")))); });
var templateObject_1, templateObject_2;
//# sourceMappingURL=icon-base.js.map